/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeTableCategory } from "../../d-table-category";
import { DThemeDarkTableHeader } from "./d-theme-dark-table-header";

export class DThemeDarkTableCategory extends DThemeDarkTableHeader implements DThemeTableCategory {}
